import { render, staticRenderFns } from "./SyncEventFlagModal.vue?vue&type=template&id=5fd07562&scoped=true&"
import script from "./SyncEventFlagModal.vue?vue&type=script&lang=js&"
export * from "./SyncEventFlagModal.vue?vue&type=script&lang=js&"
import style0 from "./SyncEventFlagModal.vue?vue&type=style&index=0&id=5fd07562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd07562",
  null
  
)

export default component.exports